/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from '@emotion/styled';
import Icon from 'components/icon';
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAlert } from 'providers/AlertModalProvider';
import postData from 'services/postData';
import PinInput from 'react-pin-input';
import PageLoader from 'components/custom/animate-component/PageLoader';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    margin-left: auto;
    max-width: 350px;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

function ResetPinModal({
  show,
  handleClose,
  pinType,
  pinNo,
  onSubmit,
  modalType = 'edit'
}) {
  const [loading, setLoading] = useState(false);
  const [pinRef, setPinRef] = useState(null);
  const [pin, setPin] = useState('');
  const [isPinCorrect, setIsPinCorrect] = useState(true);
  const { showAlert } = useAlert();
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const [confirmPin, setConfirmPin] = useState('');
  const [isConfirmPinCorrect, setIsConfirmPinCorrect] = useState(true);

  const handleOnSubmit = async () => {
    if (modalType !== 'create') {
      if (pin !== confirmPin) {
        setIsConfirmPinCorrect(false);
        return;
      }
    }
    onSubmit(pinType, pin, confirmPin);
    handleClose();
  };

  return (
    <CustomModal show={show} onHide={handleClose} backdrop="static" centered>
      <Modal.Header className="border-0 d-flex justify-content-center">
        <Modal.Title>
          <Icon
            icon="streamline:lock-reset"
            className="text-warning"
            fontSize="48px"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2 text-center">
          <p className="mb-2 text-1000">
            {pinType === 'loginPin' ? 'Login' : 'Transaction'} PIN
          </p>
        </div>
        <div className="d-flex align-items-center flex-column">
          <div>
            {modalType !== 'create' && (
              <Form.Label className="ps-1">New Pin</Form.Label>
            )}
            <PinInput
              initialValue={pinNo}
              length={4}
              type="numeric"
              inputFocusStyle={{ borderColor: '#004DFF' }}
              inputStyle={{
                borderWidth: '1px',
                borderRadius: '8px',
                textAlign: 'center',
                height: '40px'
              }}
              ref={p => setPinRef(p)}
              onChange={val => {
                setPin(val);
                if (!isPinCorrect) setIsPinCorrect(true);
              }}
            />
            {!isPinCorrect && (
              <small className="text-danger">Error resetting PIN</small>
            )}
          </div>
          {modalType !== 'create' && (
            <div className="mt-3">
              <Form.Label className="ps-1">Confirm Pin</Form.Label>

              <PinInput
                length={4}
                type="numeric"
                inputFocusStyle={{ borderColor: '#004DFF' }}
                inputStyle={{
                  borderWidth: '1px',

                  borderRadius: '8px',

                  textAlign: 'center',

                  height: '40px'
                }}
                onChange={val => {
                  setConfirmPin(val);

                  if (!isConfirmPinCorrect) setIsConfirmPinCorrect(true);
                }}
              />

              {!isConfirmPinCorrect && (
                <small className="text-danger">Pins do not match</small>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <Button
          disabled={loading}
          variant="outline-secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="warning"
          disabled={
            pin.length !== 4 ||
            (confirmPin.length !== 4 && modalType !== 'create') ||
            loading
          }
          onClick={handleOnSubmit}
        >
          Save
        </Button>
      </Modal.Footer>
      <PageLoader
        loading={loading}
        loadingMessage={`Resetting ${pinType === 'loginPin' ? 'Login' : 'Transaction'} PIN`}
      />
    </CustomModal>
  );
}

export default ResetPinModal;
